import React from 'react';
import { useParams } from 'react-router-dom';
import Wrapper from '../Wrapper';
import { StudentActivityContainer } from './StudentActivity';

export const StudentActivityWrapper = (props) => {
  const { courseId } = useParams();

  return (
    <div style={{ maxWidth: '375px' }}>
      <Wrapper>
        <StudentActivityContainer courseId={courseId} {...props} />
      </Wrapper>
    </div>
  );
};
